
import { useState } from 'react';
import {
  heatingServicesItems,
  heatingIndoorAirQualityItems,
} from '../../../mocks/heatingDropdownData';

type SubCategory = 'heating-services' | 'indoor-air-quality';

export default function HeatingMegaDropdown() {
  const [activeSubCategory, setActiveSubCategory] =
    useState<SubCategory>('heating-services');

  const items =
    activeSubCategory === 'heating-services'
      ? heatingServicesItems
      : heatingIndoorAirQualityItems;

  return (
    <div className="absolute top-full left-0 w-full bg-white shadow-2xl border-t border-gray-100 rounded-b-xl overflow-hidden animate-fadeIn">
      <div className="max-w-7xl mx-auto px-6 py-6">
        {/* Subcategory Tabs */}
        <div className="flex items-center gap-2 mb-6">
          <button
            onClick={() => setActiveSubCategory('heating-services')}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
              activeSubCategory === 'heating-services'
                ? 'bg-[#B22234] text-white shadow-lg shadow-[#B22234]/20'
                : 'bg-[#1B3A6B]/5 text-[#1B3A6B] hover:bg-[#1B3A6B]/10'
            }`}
          >
            <span className="flex items-center gap-2">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              Heating Services
            </span>
          </button>

          <button
            onClick={() => setActiveSubCategory('indoor-air-quality')}
            className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
              activeSubCategory === 'indoor-air-quality'
                ? 'bg-[#B22234] text-white shadow-lg shadow-[#B22234]/20'
                : 'bg-[#1B3A6B]/5 text-[#1B3A6B] hover:bg-[#1B3A6B]/10'
            }`}
          >
            <span className="flex items-center gap-2">
              <i className="ri-leaf-line w-4 h-4 flex items-center justify-center"></i>
              Indoor Air Quality
            </span>
          </button>
        </div>

        {/* Service Cards Grid */}
        <div
          className={`grid gap-4 ${
            activeSubCategory === 'heating-services'
              ? 'grid-cols-5'
              : 'grid-cols-6'
          }`}
        >
          {items.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className="group rounded-lg overflow-hidden border border-gray-100 hover:border-[#B22234]/20 hover:shadow-lg transition-all duration-300 cursor-pointer bg-white"
            >
              <div className="w-full h-[130px] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - Voltis Florida Heating Services`}
                  title={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3">
                <h4 className="text-sm font-bold text-[#1B3A6B] mb-1 group-hover:text-[#B22234] transition-colors">
                  {item.title}
                </h4>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-5 pt-4 border-t border-gray-100 flex items-center justify-between">
          <p className="text-xs text-gray-400">
            Need help choosing the right heating service? Our experts are
            standing by.
          </p>
          <a
            href="tel:+18005551234"
            className="flex items-center gap-2 text-sm font-semibold text-[#B22234] hover:text-[#8B1A29] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill w-4 h-4 flex items-center justify-center"></i>
            Call (800) 555-1234
          </a>
        </div>
      </div>
    </div>
  );
}
